import React from 'react';
import {Route, Routes, Outlet} from 'react-router-dom'
import ListWrapper from './list/ListWrapper'

const SupportPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/' element={<ListWrapper />} />
    </Route>
  </Routes>
)

export default SupportPage
